'use client';

import * as React from 'react';
import { useProfileDataQuery } from '../../hooks/use-profile-data-query';
import { Cover } from '../cover';
import { SkeletonProfile } from '../skeleton-profile';
import { Tabs } from '../tabs';
import { UserInfo } from '../user-info';
import * as Styled from './profile-page.styled';
export const PrivateProfilePage = React.memo(function PrivateProfilePage({
  children
}: React.PropsWithChildren) {
  const {
    data,
    isLoading
  } = useProfileDataQuery();
  if (!data || isLoading) {
    // In case of an error, it will be thrown to `ErrorBoundary`
    return <SkeletonProfile />;
  }
  return <>
      <Cover />
      <Styled.UserInfo>
        <UserInfo plariumId={data.id} username={data.name} avatar={data.avatar} />
      </Styled.UserInfo>
      <Styled.Main>
        <Tabs />
        {children}
      </Styled.Main>
    </>;
});